"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseOrderActions = void 0;
var PurchaseOrderActions;
(function (PurchaseOrderActions) {
    PurchaseOrderActions["SUBMIT_FOR_APPROVAL"] = "SUBMIT_FOR_APPROVAL";
    PurchaseOrderActions["SUBMIT_FOR_REDO"] = "SUBMIT_FOR_REDO";
    PurchaseOrderActions["SUBMIT_FOR_FULFILLMENT"] = "SUBMIT_FOR_FULFILLMENT";
    PurchaseOrderActions["DENY"] = "DENY";
    PurchaseOrderActions["APPROVE"] = "APPROVE";
    PurchaseOrderActions["SAVE_AS_DRAFT"] = "SAVE_AS_DRAFT";
    PurchaseOrderActions["PURCHASE_ORDER_CONFIRMED"] = "PURCHASE_ORDER_CONFIRMED";
    PurchaseOrderActions["CREATE_CARD"] = "CREATE_CARD";
    PurchaseOrderActions["CLOSE_PURCHASE_ORDER"] = "CLOSE_PURCHASE_ORDER";
})(PurchaseOrderActions || (exports.PurchaseOrderActions = PurchaseOrderActions = {}));
